import React, { useContext, useEffect } from "react";
import { ChangeEvent, useState } from "react";
import { MenuItem, Select, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { TableFooter, TablePagination } from "@mui/material";
import { Paper, Stack, TableBody } from "@mui/material";
import { BarraDeFerramentas } from "../../../Components/barra-de-ferramentas/BarraDeFerramentas";
import TablePaginationActions from "../../../Components/Pagination/pagination";
import { ButtonCadernos } from "../../../Components/barra-de-ferramentas/ButtonCadernos";
import { StyledTableCell, StyledTableHead, } from "../../../Styles/tabelCellStyled/customTableCell";
import { CustomTextField, CustomThemeProvider, } from "../../../Styles/theme/customThemeprovider";
import BasicPopover from "../../../Components/Popover";
import { IManeioEPecuario } from "../../../Interfaces/cadernos/caderno5/interfaces5C";
import ConfirmDialog from "../../../Components/CustomDialog/customdialog";
import { del, get, post } from "../../../Services/tokenConfig";
import { func_print } from "../../../Func_genericas/func_print";
import { useLocation } from "react-router-dom";
import { format_strings_to_numbers } from "../../../Componentes_modulo/formulas_genericas/formulas_genericas";
import { formatarNumero_recebido_com_casa_decimais } from "../../../Func_genericas/formatar_numero_formato_pt";
import LoadingVulpes from "../../../Styles/Loader/loading";
import { AuthContext } from "../../../AuthContext/AuthContext";
import { IZonaHomogenea } from "../../../Interfaces/cadernos/zona_homogenea";
import { mensagem_tem_a_certeza_de_apagar_alteracoes } from "../../../Func_genericas/valores_estaticos";


interface IExtraProps {
  isLoading: boolean;
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  setOpenSnackSuccess: React.Dispatch<React.SetStateAction<boolean>>;
  setOpenSnackError: React.Dispatch<React.SetStateAction<boolean>>;
  setMessage: React.Dispatch<React.SetStateAction<string>>;
  set_especie_ou_lote_homegenio_selecionada: React.Dispatch<React.SetStateAction<IZonaHomogenea | undefined>>;
  especie_ou_lote_homegenio_lista: IZonaHomogenea[] | undefined;
  especie_ou_lote_homegenio_selecionada: IZonaHomogenea | undefined;
}

export const ManeioEPecuarioForm: React.FC<IExtraProps> = ({
  set_especie_ou_lote_homegenio_selecionada,
  especie_ou_lote_homegenio_lista,
  especie_ou_lote_homegenio_selecionada,
  isLoading,
  setIsLoading,
  setMessage,
  setOpenSnackError,
  setOpenSnackSuccess,
}) => {
  const location = useLocation();
  const auth = useContext(AuthContext);
  const is_historico = location.state?.is_historico ?? false;

  const [showNewRow, setShowNewRow] = useState(false);

  const [openDeleteManeio, setOpenDeleteManeio] = React.useState(false);

  const [rowsManeio, setRowsManeio] = useState<IManeioEPecuario[]>([]);
  const [maneio, setManeio] = useState<IManeioEPecuario>();

  const [error_parqueamento, set_error_parqueamento] = useState<boolean>(false);
  const [error_cn_out_dez, set_error_cn_out_dez] = useState<boolean>(false);
  const [error_cn_ja_fev, set_error_cn_ja_fev] = useState<boolean>(false);
  const [error_cn_mar_mai, set_error_cn_mar_mai] = useState<boolean>(false);
  const [error_cn_jun_set, set_error_cn_jun_set] = useState<boolean>(false);
  const message_apenas_numero = ("Apenas números são aceites");
  const [flag_editado, set_flag_editado] = React.useState(false);
  const [open_modal_tem_a_certeza_que_quer_apagar_alteracoes, set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes] = React.useState(false);

  const handleCloseDialog = () => {
    handle_fechar_nova_linha_limpar_campos();
    setManeio(undefined)

    set_error_cn_out_dez(false);
    set_error_cn_ja_fev(false);
    set_error_cn_mar_mai(false);
    set_error_cn_jun_set(false);
    set_error_parqueamento(false)
    set_flag_editado(false)
    set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)
  };




  const handle_fechar_nova_linha_limpar_campos = () => {
    setManeio(undefined)
    setShowNewRow(false);
  }

  async function getManeio() {
    setIsLoading(true);
    try {
      let res = await get(auth.token.cookie_token, `/get_reg_oper_culturais_PP_dois_5c_rosto/${location.state.id_rosto}`);

      if (res.status === 200) {
        setRowsManeio(res.data.result);
      }
      setIsLoading(false);
    } catch (error) {
      func_print("getManeio", error, true);
      setMessage("Erro ao efetuar a sua operação!");
      setOpenSnackError(true);
      setIsLoading(false);
    }
  }



  useEffect(() => {
    (async () => {
      await getManeio();
    })();
  }, []);

  const handleNewRow = () => {
    setManeio(undefined);
    setManeio((prevManeio: any) => ({
      ...prevManeio,
      area: especie_ou_lote_homegenio_selecionada?.area,
      zona_homo: especie_ou_lote_homegenio_selecionada?.zona_homogenea
    }));
    setShowNewRow(true);
  }

  const onInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    set_flag_editado(true)

    if (name === "parqueamento") {
      if (value.trim() === "") {
        set_error_parqueamento(true);
      } else {
        set_error_parqueamento(false);
      }
      setManeio((prevAzoto: any) => ({
        ...prevAzoto,
        [name]: value,
      }));
    } else if (name === "cn_out_dez") {

      if (/[a-zA-Z]/.test(value)) {
        set_error_cn_out_dez(true);
        setManeio((prevAzoto: any) => ({
          ...prevAzoto,
          [name]: format_strings_to_numbers(value, false),

        }));
      } else {
        set_error_cn_out_dez(false);

        let aux_value1 = format_strings_to_numbers(value)
        let aux_value = typeof (aux_value1) === 'number' ? aux_value1 : 0

        let aux = maneio?.area !== null && maneio?.area !== undefined ? aux_value / maneio?.area : 0

        setManeio((prevAzoto: any) => ({
          ...prevAzoto,
          [name]: format_strings_to_numbers(value, false),
          ["cn_ha_out_dez"]: aux,

        }));
      }


    } else if (name === "cn_ja_fev") {

      if (/[a-zA-Z]/.test(value)) {
        set_error_cn_ja_fev(true);
        setManeio((prevAzoto: any) => ({
          ...prevAzoto,
          [name]: format_strings_to_numbers(value, false),
        }));
      } else {
        set_error_cn_ja_fev(false);
        let aux_value1 = format_strings_to_numbers(value)
        let aux_value = typeof (aux_value1) === 'number' ? aux_value1 : 0

        let aux = maneio?.area !== null && maneio?.area !== undefined ? aux_value / maneio?.area : 0

        setManeio((prevAzoto: any) => ({
          ...prevAzoto,
          [name]: format_strings_to_numbers(value, false),
          ["cn_ha_ja_fev"]: aux,

        }));
      }

    } else if (name === "cn_mar_mai") {

      if (/[a-zA-Z]/.test(value)) {
        set_error_cn_mar_mai(true);
        setManeio((prevAzoto: any) => ({
          ...prevAzoto,
          [name]: format_strings_to_numbers(value, false),
        }));
      } else {
        set_error_cn_mar_mai(false);
        let aux_value1 = format_strings_to_numbers(value)
        let aux_value = typeof (aux_value1) === 'number' ? aux_value1 : 0

        let aux = maneio?.area !== null && maneio?.area !== undefined ? aux_value / maneio?.area : 0

        setManeio((prevAzoto: any) => ({
          ...prevAzoto,
          [name]: format_strings_to_numbers(value, false),
          ["cn_ha_mar_mai"]: aux,

        }));
      }

    } else if (name === "cn_jun_set") {

      if (/[a-zA-Z]/.test(value)) {
        set_error_cn_jun_set(true);
        setManeio((prevAzoto: any) => ({
          ...prevAzoto,
          [name]: format_strings_to_numbers(value, false),
        }));
      } else {
        set_error_cn_jun_set(false);
        let aux_value1 = format_strings_to_numbers(value)
        let aux_value = typeof (aux_value1) === 'number' ? aux_value1 : 0

        let aux = maneio?.area !== null && maneio?.area !== undefined ? aux_value / maneio?.area : 0

        setManeio((prevAzoto: any) => ({
          ...prevAzoto,
          [name]: format_strings_to_numbers(value, false),
          ["cn_ha_jun_set"]: aux,

        }));
      }

    } else {
      setManeio((prevManeio: any) => ({
        ...prevManeio,
        [name]: value,
      }));
    }
  };

  const handleSaveManeio = async () => {

    if (maneio?.zona_homo === undefined ||
      maneio.parqueamento === undefined || maneio.parqueamento.trim() === "") {
      if (maneio?.parqueamento === undefined || maneio?.parqueamento.trim() === "") {
        set_error_parqueamento(true);
      }
      setMessage("Preencha todos os campos obrigatórios!");
      setOpenSnackError(true);
    } else

      try {
        setIsLoading(true);
        let res = await post(auth.token.cookie_token, "new_reg_oper_culturais_PP_dois_5c", {
          payload: {
            id_regis_ope_cult: 0,
            zona_homo: maneio?.zona_homo === undefined ? null : maneio.zona_homo,
            parqueamento: maneio?.parqueamento === undefined ? null : maneio.parqueamento,
            area: maneio?.area === undefined ? null : maneio.area,
            cn_out_dez: maneio?.cn_out_dez === undefined ? null : maneio.cn_out_dez,
            cn_ja_fev: maneio?.cn_ja_fev === undefined ? null : maneio.cn_ja_fev,
            cn_mar_mai: maneio?.cn_mar_mai === undefined ? null : maneio.cn_mar_mai,
            cn_jun_set: maneio?.cn_jun_set === undefined ? null : maneio.cn_jun_set,
            cn_ha_out_dez: maneio?.cn_ha_out_dez === undefined ? null : maneio.cn_ha_out_dez,
            cn_ha_ja_fev: maneio?.cn_ha_ja_fev === undefined ? null : maneio.cn_ha_ja_fev,
            cn_ha_mar_mai: maneio?.cn_ha_mar_mai === undefined ? null : maneio.cn_ha_mar_mai,
            cn_ha_jun_set: maneio?.cn_ha_jun_set === undefined ? null : maneio.cn_ha_jun_set,
            id_rosto: location.state.id_rosto,
            last_update: new Date().toISOString(),
            create_date: new Date().toISOString(),
            uuid: "",
          }
        });

        if (res.status === 200) {
          setMessage("Gravado com sucesso!");
          setOpenSnackSuccess(true);
          setShowNewRow(false);
          setManeio(undefined);
          setRowsManeio((prevRows) => {
            return [...prevRows, res.data.result];
          })
          set_error_cn_out_dez(false);
          set_error_cn_ja_fev(false);
          set_error_cn_mar_mai(false);
          set_error_cn_jun_set(false);
          set_flag_editado(false)

        } else {
          setMessage("Erro ao gravar!");
          setOpenSnackError(true);
        }
        setIsLoading(false);
      } catch (error) {
        func_print("handleSaveManeio", error, true);
        if ((error as any)?.response?.data?.message) {
          setMessage((error as any).response.data.message);
        } else {
          setMessage("Erro ao efetuar a sua operação!");
        }
        setOpenSnackError(true);
        setIsLoading(false);
      }
  };

  // EDIT
  const handleEdit = (obj_maneio: IManeioEPecuario) => {
    setManeio(obj_maneio);
    let aux_obj_zona_homogenea_selecionada = especie_ou_lote_homegenio_lista?.find((el: IZonaHomogenea) => el.zona_homogenea === obj_maneio.zona_homo)

    if (aux_obj_zona_homogenea_selecionada !== undefined) {
      set_especie_ou_lote_homegenio_selecionada(aux_obj_zona_homogenea_selecionada)
    }
  };



  const handleUpdate = async () => {


    if (maneio?.zona_homo === undefined ||
      maneio?.parqueamento === undefined || maneio?.parqueamento.trim() === "") {
      if (maneio?.parqueamento === undefined || maneio?.parqueamento.trim() === "") {
        set_error_parqueamento(true);
      }
      setOpenSnackError(true);
    } else {
      try {
        setIsLoading(true);

        let res = await post(auth.token.cookie_token, `update_reg_oper_culturais_PP_dois_5c`, {
          payload: {
            id_regis_ope_cult: maneio?.id_regis_ope_cult,
            zona_homo: maneio?.zona_homo === undefined ? null : maneio.zona_homo,
            parqueamento: maneio?.parqueamento === undefined ? null : maneio.parqueamento,
            area: maneio?.area === undefined ? null : maneio.area,
            cn_out_dez: maneio?.cn_out_dez === undefined ? null : maneio.cn_out_dez,
            cn_ja_fev: maneio?.cn_ja_fev === undefined ? null : maneio.cn_ja_fev,
            cn_mar_mai: maneio?.cn_mar_mai === undefined ? null : maneio.cn_mar_mai,
            cn_jun_set: maneio?.cn_jun_set === undefined ? null : maneio.cn_jun_set,
            cn_ha_out_dez: maneio?.cn_ha_out_dez === undefined ? null : maneio.cn_ha_out_dez,
            cn_ha_ja_fev: maneio?.cn_ha_ja_fev === undefined ? null : maneio.cn_ha_ja_fev,
            cn_ha_mar_mai: maneio?.cn_ha_mar_mai === undefined ? null : maneio.cn_ha_mar_mai,
            cn_ha_jun_set: maneio?.cn_ha_jun_set === undefined ? null : maneio.cn_ha_jun_set,
            id_rosto: maneio?.id_rosto,
            last_update: new Date().toISOString(),
            create_date: new Date().toISOString(),
            uuid: "",
          }
        });

        if (res.status === 200) {
          setMessage("Registado com sucesso!");
          const updatedRows = rowsManeio.map((row) => {
            if (row.id_regis_ope_cult === maneio.id_regis_ope_cult) {
              return res.data.result
            } else {
              return row
            }
          });
          setRowsManeio(updatedRows !== undefined ? updatedRows : []);
          setManeio(undefined);
          setOpenSnackSuccess(true);
          set_error_cn_out_dez(false);
          set_error_cn_ja_fev(false);
          set_error_cn_mar_mai(false);
          set_error_cn_jun_set(false);
          set_flag_editado(false)

        } else {
          setMessage("Erro ao gravar!");
          setOpenSnackError(true);
        }
        setIsLoading(false);
      } catch (error) {
        func_print("handleUpdate", error, true);
        setMessage("Erro ao gravar!");
        setOpenSnackError(true);
        setIsLoading(false);
      }



    };
  };

  // Delete
  const handleClickOpenDeleteManeio = (obj: IManeioEPecuario) => {
    setManeio(obj);
    setOpenDeleteManeio(true);
  };

  const handleDeleteManeio = async () => {
    try {
      setIsLoading(true);
      let res = await del(auth.token.cookie_token, `/delete__reg_oper_culturais_PP_dois_5c/${maneio?.id_regis_ope_cult}`);

      if (res.status === 200) {
        setMessage("Registo eliminado com sucesso!");
        setOpenDeleteManeio(false);
        setRowsManeio((oldRows) => [
          ...oldRows.filter((oldRow) => oldRow.id_regis_ope_cult !== maneio?.id_regis_ope_cult),
        ]);
        setManeio(undefined);

        setOpenSnackSuccess(true);
      } else {
        setMessage("Erro ao eliminar o registo!");
        setOpenSnackError(true);
      }
      setIsLoading(false);
    } catch (error) {
      func_print("handleDeleteManeio", error, true);
      setMessage("Erro ao eliminar o registo!");
      setOpenSnackError(true);
      setIsLoading(false);
    }
  };

  /*****************  PAGINAÇÃO ********************** */
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  // Avoid a layout jump when reaching the last page with empty rows.
  // const emptyRows =
  //   page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handle_change_zona_homogenea = (zona_homogenea_selecionada: string) => {

    let aux_obj_zona_homogenea_selecionada = especie_ou_lote_homegenio_lista?.find((el: IZonaHomogenea) => el.zona_homogenea === zona_homogenea_selecionada)

    if (aux_obj_zona_homogenea_selecionada !== undefined) {
      set_especie_ou_lote_homegenio_selecionada(aux_obj_zona_homogenea_selecionada)
      setManeio((prevOperacoes: any) => ({
        ...prevOperacoes,
        area: aux_obj_zona_homogenea_selecionada?.area,
        zona_homo: aux_obj_zona_homogenea_selecionada?.zona_homogenea,
      }));
    }


  }
  return (
    <CustomThemeProvider>
      {isLoading ?
        <LoadingVulpes /> :

        <TableContainer
          component={Paper}
          variant="outlined"
          sx={{
            height: "auto",
            width: "auto",
            margin: 2,
            padding: 2,
          }}
        >



          <table width="100%">
            <TableHead>
              <TableRow>
                <TableCell
                  colSpan={10}
                  sx={{ fontWeight: 600, fontFamily: "candara", fontSize: 17, }} >
                  2 - Registo do maneio do efetivo pecuário
                </TableCell>
                <TableCell colSpan={2}>
                  <Stack direction="row" justifyContent="end">
                    {is_historico === true ? <></> :

                      <BarraDeFerramentas
                        mostrarBotaoNovo
                        textoBotaoNovo="Novo Registo"
                        aoClicarNovo={
                          handleNewRow

                        }
                      />}
                  </Stack>
                </TableCell>
              </TableRow>
              <TableRow>
                <StyledTableHead rowSpan={2}>Zona Homogénea*<BasicPopover text={"O registo das atividades deverá ser efetuado de acordo com a zona homogénea indicada no separador «caracterização das parcelas»"} /></StyledTableHead>
                <StyledTableHead rowSpan={2}>
                  <Stack direction="row" justifyContent="center" alignItems="center">
                    Parqueamento*
                    <BasicPopover
                      text={"No caso do recurso ao parquemanto da área de pastagem\n para controlar a rotação dos animais, deverá ser identificado\n o número de parque instalados por zona homogénea ou subparcela.\n\nSão aceites os seguintes valores P1, P2, P3, P4, etc.\n\nNo caso de não existirem parque preencher com P1."} />
                  </Stack>
                </StyledTableHead>
                <StyledTableHead rowSpan={2}>
                  <Stack direction="row" justifyContent="center" alignItems="center">
                    Área (ha)*
                    <BasicPopover
                      text={"Área do parque, no caso de a zona homogéne/subparcela ter sido parqueada\n para facilitar a rotação do efetivo animal. No caso de não existir\n parqueamento da área de pastagem, registar a área da Zona homogénea/subparcela. \nA área da Zona homogénea corresponde ao somatório das subparcelas que a compõem"} />
                  </Stack>
                </StyledTableHead>
                <StyledTableHead colSpan={4}>
                  <Stack direction="row" justifyContent="center" alignItems="center">
                    Animais em pastoreio (CN)
                    <BasicPopover
                      text={"Registar por cada trimestre o n.º de cabeças normais (CN) que permaneceram/pastorearam a zona homogénea em causa.\n\nNa conversão de cabeças naturais em cabeças normais devem ser utilizados os coeficientes previstos no\n Anexo I da Portaria n.º 54-C/2023 e da Portaria n.º 54-E/2023:\n\nEspécies  ......................................  Cabeças Normais (CN)\nBovinos com mais de 2 anos ............................. 1\nBovinos de 6 meses a 2 anos ........................... 0,6\nBovinos com menos de 6 meses ....................... 0,4\nOvinos com mais de 1 ano ............................... 0,15\nCaprinos com mais de 1 ano ............................ 0,15\nPorcas reprodutoras > 50kg ........................... 0,5\nOutros suínos (com mais de 3 meses) .............. 0,3\nEquídeos com mais de 6 meses ......................... 1"} />
                  </Stack>
                </StyledTableHead>
                <StyledTableHead colSpan={4}>
                  <Stack direction="row" justifyContent="center" alignItems="center">
                    Encabeçamento (CN/ha)
                    <BasicPopover
                      text={"O registo por cada trimestre do n.º de CN/ha é efetuad\no automaticamente após preenchimento dos campo de «Animais em pastoreio (CN))."} />
                  </Stack>
                </StyledTableHead>
                <StyledTableHead rowSpan={2}>Ações</StyledTableHead>
              </TableRow>
              <TableRow>
                <StyledTableHead>Out/Dez</StyledTableHead>
                <StyledTableHead>Jan/Fev</StyledTableHead>
                <StyledTableHead>Mar/Mai</StyledTableHead>
                <StyledTableHead>Jun/Set</StyledTableHead>
                <StyledTableHead sx={{ backgroundColor: "lightgray" }}> Out/Dez </StyledTableHead>
                <StyledTableHead sx={{ backgroundColor: "lightgray" }}> Jan/Fev </StyledTableHead>
                <StyledTableHead sx={{ backgroundColor: "lightgray" }}> Mar/Mai</StyledTableHead>
                <StyledTableHead sx={{ backgroundColor: "lightgray" }}> Jun/Set </StyledTableHead>
              </TableRow>
            </TableHead>
            <TableBody>
              {showNewRow && (
                <TableRow>
                  <StyledTableCell>
                    {especie_ou_lote_homegenio_lista !== undefined ? (
                      <>
                        <Select
                          value={especie_ou_lote_homegenio_selecionada?.zona_homogenea === undefined ? '' : especie_ou_lote_homegenio_selecionada?.zona_homogenea}
                          label={''}
                          name={'zona_homogenea'}
                          // defaultValue={especie_ou_lote_homegenio_selecionada?.id_cara === undefined ? 0 : especie_ou_lote_homegenio_selecionada?.id_cara}
                          sx={{
                            fontSize: 14,
                            fontFamily: "verdana",
                            minWidth: 200,
                          }}
                          onChange={(e) => handle_change_zona_homogenea(e.target.value)}
                        >

                          {especie_ou_lote_homegenio_lista.map((item: IZonaHomogenea, key) => {

                            return (
                              <MenuItem key={key} value={item.zona_homogenea}>
                                <Typography
                                  style={{
                                    fontSize: 14,
                                    fontFamily: "candara",
                                  }}
                                >
                                  {item.zona_homogenea}
                                </Typography>
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </>
                    ) : (
                      <></>
                    )}
                  </StyledTableCell>
                  <StyledTableCell>
                    <CustomTextField
                      name="parqueamento"
                      value={maneio?.parqueamento !== null && maneio?.parqueamento}
                      onChange={onInputChange}
                      error={error_parqueamento}
                      helperText={error_parqueamento ? "Preencha este campo" : ""}
                    />
                  </StyledTableCell>
                  <StyledTableCell width={100}>
                    <Typography>{especie_ou_lote_homegenio_selecionada?.area !== undefined ? formatarNumero_recebido_com_casa_decimais(especie_ou_lote_homegenio_selecionada?.area) : '0,00'}
                    </Typography>
                  </StyledTableCell>
                  <StyledTableCell width={100}>
                    <CustomTextField
                      name="cn_out_dez"
                      value={maneio?.cn_out_dez}
                      onChange={onInputChange}
                      error={error_cn_out_dez}
                      helperText={error_cn_out_dez ? message_apenas_numero : ""}
                    />
                  </StyledTableCell>
                  <StyledTableCell width={100}>
                    <CustomTextField
                      name="cn_ja_fev"
                      value={maneio?.cn_ja_fev}
                      onChange={onInputChange}
                      error={error_cn_ja_fev}
                      helperText={error_cn_ja_fev ? message_apenas_numero : ""}
                    />
                  </StyledTableCell>
                  <StyledTableCell width={100}>
                    <CustomTextField
                      name="cn_mar_mai"
                      value={maneio?.cn_mar_mai}
                      onChange={onInputChange}
                      error={error_cn_mar_mai}
                      helperText={error_cn_mar_mai ? message_apenas_numero : ""}
                    />
                  </StyledTableCell>
                  <StyledTableCell width={100}>
                    <CustomTextField
                      name="cn_jun_set"
                      value={maneio?.cn_jun_set}
                      onChange={onInputChange}
                      error={error_cn_jun_set}
                      helperText={error_cn_jun_set ? message_apenas_numero : ""}
                    />
                  </StyledTableCell>
                  <StyledTableCell>
                    {maneio?.cn_ha_out_dez !== undefined ? formatarNumero_recebido_com_casa_decimais(maneio.cn_ha_out_dez) : ""}
                  </StyledTableCell>
                  <StyledTableCell>
                    {maneio?.cn_ha_ja_fev !== undefined ? formatarNumero_recebido_com_casa_decimais(maneio.cn_ha_ja_fev) : ""}
                  </StyledTableCell>
                  <StyledTableCell>
                    {maneio?.cn_ha_mar_mai !== undefined ? formatarNumero_recebido_com_casa_decimais(maneio.cn_ha_mar_mai) : ""}
                  </StyledTableCell>
                  <StyledTableCell>
                    {maneio?.cn_ha_jun_set !== undefined ? formatarNumero_recebido_com_casa_decimais(maneio.cn_ha_jun_set) : ""}
                  </StyledTableCell>

                  <StyledTableCell>
                    <Stack direction="row" justifyContent="center">
                      <ButtonCadernos
                        mostrarBotaoCancelar
                        aoClicarCancelar={() => {
                          if (flag_editado) {
                            set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                          } else {
                            set_error_cn_out_dez(false);
                            set_error_cn_ja_fev(false);
                            set_error_cn_mar_mai(false);
                            set_error_cn_jun_set(false);
                            handle_fechar_nova_linha_limpar_campos();
                          }

                        }}
                        mostrarBotaoGravar
                        aoClicarGravar={() => handleSaveManeio()}
                      />
                    </Stack>
                  </StyledTableCell>
                </TableRow>
              )}

              {(rowsPerPage > 0
                ? rowsManeio.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                : rowsManeio
              ).map((row, key) => (
                <TableRow key={key}>
                  {maneio?.id_regis_ope_cult === row.id_regis_ope_cult ? (
                    <>
                      <StyledTableCell>
                        {especie_ou_lote_homegenio_lista !== undefined ? (
                          <>
                            <Select
                              value={especie_ou_lote_homegenio_selecionada?.zona_homogenea === undefined ? '' : especie_ou_lote_homegenio_selecionada?.zona_homogenea}
                              label={''}
                              name={'zona_homogenea'}
                              // defaultValue={especie_ou_lote_homegenio_selecionada?.id_cara === undefined ? 0 : especie_ou_lote_homegenio_selecionada?.id_cara}
                              sx={{
                                fontSize: 14,
                                fontFamily: "verdana",
                                minWidth: 200,
                              }}
                              onChange={(e) => handle_change_zona_homogenea(e.target.value)}
                            >

                              {especie_ou_lote_homegenio_lista.map((item: IZonaHomogenea, key) => {

                                return (
                                  <MenuItem key={key} value={item.zona_homogenea}>
                                    <Typography
                                      style={{
                                        fontSize: 14,
                                        fontFamily: "candara",
                                      }}
                                    >
                                      {item.zona_homogenea}
                                    </Typography>
                                  </MenuItem>
                                );
                              })}
                            </Select>
                          </>
                        ) : (
                          <></>
                        )}
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="parqueamento"
                          value={maneio?.parqueamento}
                          onChange={onInputChange}
                          error={error_parqueamento}
                          helperText={error_parqueamento ? "Preencha este campo" : ""}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <Typography>{especie_ou_lote_homegenio_selecionada?.area !== undefined ? formatarNumero_recebido_com_casa_decimais(especie_ou_lote_homegenio_selecionada?.area) : '0,00'}
                        </Typography>
                      </StyledTableCell>

                      <StyledTableCell>
                        <CustomTextField
                          name="cn_out_dez"
                          value={maneio?.cn_out_dez}
                          onChange={onInputChange}
                          error={error_cn_out_dez}
                          helperText={error_cn_out_dez ? message_apenas_numero : ""}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="cn_ja_fev"
                          value={maneio?.cn_ja_fev}
                          onChange={onInputChange}
                          error={error_cn_ja_fev}
                          helperText={
                            error_cn_ja_fev ? message_apenas_numero : ""
                          }
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="cn_mar_mai"
                          value={maneio?.cn_mar_mai}
                          onChange={onInputChange}
                          error={error_cn_mar_mai}
                          helperText={
                            error_cn_mar_mai ? message_apenas_numero : ""
                          }
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="cn_jun_set"
                          value={maneio?.cn_jun_set}
                          onChange={onInputChange}
                          error={error_cn_jun_set}
                          helperText={
                            error_cn_jun_set ? message_apenas_numero : ""
                          }
                        />
                      </StyledTableCell>
                      <StyledTableCell sx={{ backgroundColor: "lightgray" }}>
                        {maneio?.cn_ha_out_dez !== undefined ? formatarNumero_recebido_com_casa_decimais(maneio.cn_ha_out_dez) : ""}

                      </StyledTableCell>
                      <StyledTableCell sx={{ backgroundColor: "lightgray" }}>
                        {maneio?.cn_ha_ja_fev !== undefined ? formatarNumero_recebido_com_casa_decimais(maneio.cn_ha_ja_fev) : ""}

                      </StyledTableCell>
                      <StyledTableCell sx={{ backgroundColor: "lightgray" }}>
                        {maneio?.cn_ha_mar_mai !== undefined ? formatarNumero_recebido_com_casa_decimais(maneio.cn_ha_mar_mai) : ""}

                      </StyledTableCell>
                      <StyledTableCell sx={{ backgroundColor: "lightgray" }}>
                        {maneio?.cn_ha_jun_set !== undefined ? formatarNumero_recebido_com_casa_decimais(maneio.cn_ha_jun_set) : ""}

                      </StyledTableCell>
                    </>
                  ) : (
                    <>
                      <StyledTableCell>{row.zona_homo} </StyledTableCell>
                      <StyledTableCell>{row.parqueamento} </StyledTableCell>
                      <StyledTableCell>{row.area} </StyledTableCell>
                      <StyledTableCell>{formatarNumero_recebido_com_casa_decimais(row.cn_out_dez)} </StyledTableCell>
                      <StyledTableCell>{formatarNumero_recebido_com_casa_decimais(row.cn_ja_fev)} </StyledTableCell>
                      <StyledTableCell>{formatarNumero_recebido_com_casa_decimais(row.cn_mar_mai)} </StyledTableCell>
                      <StyledTableCell>{formatarNumero_recebido_com_casa_decimais(row.cn_jun_set)} </StyledTableCell>
                      <StyledTableCell>{formatarNumero_recebido_com_casa_decimais(row.cn_ha_out_dez)}</StyledTableCell>
                      <StyledTableCell>{formatarNumero_recebido_com_casa_decimais(row.cn_ha_ja_fev)}</StyledTableCell>
                      <StyledTableCell>{formatarNumero_recebido_com_casa_decimais(row.cn_ha_mar_mai)}</StyledTableCell>
                      <StyledTableCell>{formatarNumero_recebido_com_casa_decimais(row.cn_ha_jun_set)}</StyledTableCell>
                    </>
                  )}
                  {maneio?.id_regis_ope_cult === row.id_regis_ope_cult ? (
                    <StyledTableCell>
                      <ButtonCadernos
                        mostrarBotaoGravar
                        aoClicarGravar={() => handleUpdate()}
                        mostrarBotaoCancelar
                        aoClicarCancelar={() => {
                          if (flag_editado) {
                            set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                          } else {
                            set_error_cn_out_dez(false);
                            set_error_cn_ja_fev(false);
                            set_error_cn_mar_mai(false);
                            set_error_cn_jun_set(false);
                            setManeio(undefined)
                          }

                        }}
                      />
                    </StyledTableCell>
                  ) : (
                    <StyledTableCell>
                      {is_historico === true ? <></> :

                        <ButtonCadernos
                          mostrarBotaoEditar
                          aoClicarEditar={() => {
                            handleEdit(row)
                            setShowNewRow(false)
                          }}
                          mostrarBotaoApagar
                          aoClicarApagar={() => handleClickOpenDeleteManeio(row)}
                        />}
                    </StyledTableCell>
                  )}
                </TableRow>
              ))}
            </TableBody>

            <TableFooter>
              <TableRow sx={{ width: "100%" }}>
                <TableCell colSpan={5}>
                  <Typography style={{ fontSize: 14, fontFamily: "candara" }}>
                    * Campos de preenchimento obrigatório
                  </Typography>
                </TableCell>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25, { label: "All", value: -1 }]}
                  colSpan={9}
                  count={rowsManeio.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  labelDisplayedRows={({ from, to, count }) => {
                    return `${from}–${to} de ${count !== -1 ? count : `mais do que ${to}`}`;
                  }}
                  labelRowsPerPage={'Linhas por página'}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  ActionsComponent={TablePaginationActions}
                />
              </TableRow>
            </TableFooter>
            <ConfirmDialog
              open={openDeleteManeio}
              onClose={() => setOpenDeleteManeio(false)}
              onConfirm={handleDeleteManeio}
              message="Deseja eliminar o registo?"
            />
            <ConfirmDialog
              open={open_modal_tem_a_certeza_que_quer_apagar_alteracoes}
              onClose={() => set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)}
              onConfirm={() => handleCloseDialog()}
              message={mensagem_tem_a_certeza_de_apagar_alteracoes}
            />
          </table>
        </TableContainer>
      }
    </CustomThemeProvider>
  );
};
